import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { DealerActions } from 'src/app/common/store/actions/dealer.actions';

import { selectDealerProfile, selectAllCarImagesFolders, selectCustomerCarsByBusinessLine, selectDealerFetchingResults } from 'src/app/common/store/state/app.state';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { Car } from 'src/app/public/car/models/car.model';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { TransactionRole, TransactionStage } from 'src/app/public/common/constants/common-basic-data';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { FileData } from 'src/app/public/common/models/file-data.model';


@Component({
    selector: 'app-customer-buy',
    templateUrl: './customer-buy.component.html',
    styleUrls: ['./customer-buy.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class CustomerBuyComponent implements OnInit {

  myBuyCars$: Observable<Car[]>;
  carImagesFolders$: Observable<Map<string, Array<FileData>>>;
  myProfile$: Observable<Dealer>;
  
  businessLine: CarBusinessLine = CarBusinessLine.BUY;
  objectSource: ObjectSource = ObjectSource.BUY;
  //transactionStages: TransactionStage[] = [TransactionStage.ONGOING];
  transactionRole: TransactionRole = TransactionRole.CUSTOMER

  TransactionStage = TransactionStage

  fetchingResults$: Observable<boolean>;

  data?: any;

  constructor(

    private store: Store, 
    private router: Router,
    private route: ActivatedRoute
    ) {

      this.fetchingResults$ = store.select(selectDealerFetchingResults);

      this.carImagesFolders$ = store.select(selectAllCarImagesFolders);

      this.myProfile$ = store.select(selectDealerProfile);

      this.myBuyCars$ = store.select(selectCustomerCarsByBusinessLine(this.businessLine))

    }

    ngOnInit() {

      this.route.data.subscribe(
          data => {
            //this.transactionStages = data['transactionStages'];
            this.data = data;
            this.store.dispatch(DealerActions.providerOffersFetchMySubmit({ transactionRole: this.transactionRole, businessLine: this.businessLine, transactionStages: this.data.transactionStages }));
          }
        )  

      //this.store.dispatch(DealerActions.fetchCustomerCarsSubmit({businessLine: this.businessLine, favoritesOnly: false }));
      
  }

}
